import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=05a51872&scoped=true"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"
import style0 from "./home-page.vue?vue&type=style&index=0&id=05a51872&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a51872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a51872')) {
      api.createRecord('05a51872', component.options)
    } else {
      api.reload('05a51872', component.options)
    }
    module.hot.accept("./home-page.vue?vue&type=template&id=05a51872&scoped=true", function () {
      api.rerender('05a51872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/home-page.vue"
export default component.exports